import React from 'react';

export default function Erreur404() {
  return (
    <div>
      <h1>Erreur 404</h1>
    </div>
  );
}
